import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';
const lineSolid = createElement(SVG, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}, createElement(Path, {
  d: "M5 11.25h14v1.5H5z"
}));
export default lineSolid;
//# sourceMappingURL=line-solid.js.map